import { createReducer, on } from '@ngrx/store';
import { Pagination } from '@shared/models/pagination.model';
import { CurrentStore } from '@shared/models/store.model';

import { managedStoreAction } from '../actions/managed-store.actions';

export const managedStoreKey = 'managedStore';

export interface ManagedStoreState {
  managedStoreList: Pagination<CurrentStore>;
}

export const initialState: ManagedStoreState = {
  managedStoreList: null
};

export const managedStoreReducer = createReducer<ManagedStoreState>(
  initialState,
  on(managedStoreAction.managedStoreResponse, (state, response) => {
    return { ...state, managedStoreList: response.response };
  }),
  on(managedStoreAction.clearManagedStore, (state) => {
    return { ...state, managedStoreList: null };
  })
);
